import { t } from '@avalara/bat-apps-shared/i18n';
import { SDialog } from '@avalara/skylab-sdk/react';
import { useState } from 'react';
import type { Address } from '../../../../../types';
import InvalidAddressConfirmation from './invalid-address';
import ValidAddressConfirmation from './valid-address';

type AddressValidationDialogProps = {
  // If we get null from here no address was changed
  responseAddresses: {
    address: Address;
    validatedAddresses: {
      addressType: string;
      line1: string;
      line2: string;
      line3: string;
      city: string;
      region: string;
      country: string;
      postalCode: string;
      latitude: number;
      longitude: number;
    }[];
  };
  dialogVisible: boolean;
  setDialogVisible: (value: boolean) => void;
  setPresetAddress: (value: Address) => void;
};

const AddressValidationDialog = ({
  responseAddresses,
  dialogVisible,
  setDialogVisible,
  setPresetAddress,
}: AddressValidationDialogProps) => {
  const { address: userEnteredAddress, validatedAddresses: suggestedAddress } = responseAddresses;

  const isValidAddress = Array.isArray(suggestedAddress) && suggestedAddress.length > 0;
  const allAddresses = [...suggestedAddress, userEnteredAddress];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedAddress, setSelectedAddress] = useState<Address>(allAddresses[0]);

  const handleUseAddress = () => {
    setDialogVisible(false);
    setPresetAddress(selectedAddress);
  };

  const handleCloseDialog = () => {
    setDialogVisible(false);
    setSelectedIndex(0);
    setSelectedAddress(allAddresses[0]);
  };

  return (
    <div data-ref='buy.address-validation.dialog'>
      <SDialog open={dialogVisible} id='address-validation-dialog' onS-dismiss={handleCloseDialog}>
        {isValidAddress ? (
          <ValidAddressConfirmation
            suggestedAddresses={allAddresses}
            setSelectedAddress={setSelectedAddress}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
          />
        ) : (
          <InvalidAddressConfirmation userEnteredAddress={userEnteredAddress} />
        )}
        <div slot='footer'>
          <button
            type='button'
            className='primary margin-right-sm'
            data-ref='buy.address-validation.submit-button'
            onClick={handleUseAddress}
          >
            {'Use this address'}
          </button>
          <button
            type='button'
            className='secondary'
            data-ref='buy.address-validation.back-button'
            onClick={handleCloseDialog}
          >
            {t('client.buttons.back')}
          </button>
        </div>
      </SDialog>
    </div>
  );
};

export default AddressValidationDialog;
